import { render, staticRenderFns } from "./SaleRecoveryInfo.vue?vue&type=template&id=0023aa1d&scoped=true"
import script from "./SaleRecoveryInfo.vue?vue&type=script&lang=ts"
export * from "./SaleRecoveryInfo.vue?vue&type=script&lang=ts"
import style0 from "./SaleRecoveryInfo.vue?vue&type=style&index=0&id=0023aa1d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0023aa1d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0023aa1d')) {
      api.createRecord('0023aa1d', component.options)
    } else {
      api.reload('0023aa1d', component.options)
    }
    module.hot.accept("./SaleRecoveryInfo.vue?vue&type=template&id=0023aa1d&scoped=true", function () {
      api.rerender('0023aa1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/SaleRecoveryInfo.vue"
export default component.exports